import React from 'react';
import MixpanelContext from 'react-mixpanel';

export function useMixPanel() {
  const mixpanel = React.useContext(MixpanelContext);
  return {
    track: (eventName, properties, ...args) => {
      try {
        console.log('mixpanel tracking...', eventName, properties);
        mixpanel.track(eventName, properties, ...args);
      } catch (err) {
        console.log(err);
      }
    },
    register_once: (...args) => {
      try {
        mixpanel.register_once(...args);
      } catch (err) {
        console.log(err);
      }
    },
    register: (...args) => {
      try {
        mixpanel.register(...args);
      } catch (err) {
        console.log(err);
      }
    },
  };
}

export function withMixpanel(Component) {
  function ComponentWrapper(props) {
    const mixpanel = useMixPanel();
    return <Component mixpanel={mixpanel} {...props} />;
  }
  return ComponentWrapper;
}



// WEBPACK FOOTER //
// ./src/common/mixpanelHelper.jsx